<template>
  <div v-editable="blok" class="newsletter-download-block-content">
    <h2 v-if="downloadsTitle">
      {{ downloadsTitle }}
    </h2>
    <p
      v-if="downloadsDescription && downloadsDescription !== ' '"
      class="description"
    >
      {{ downloadsDescription }}
    </p>
  </div>
</template>

<script lang="ts" setup>
import type { BlockSubscriptionSettingsStoryblok } from '~/types/storyblok'

defineProps<{
  blok?: BlockSubscriptionSettingsStoryblok
}>()

const { downloadsTitle, downloadsDescription } = useNewsletterContent()
</script>

<style lang="less" scoped>
.newsletter-download-block-content {
  h2,
  .description {
    margin-bottom: 0 !important;
  }

  h2 + .description {
    margin-top: 0.75em;
  }
}
</style>
